import ReactStackIcon from '../../../../assets/react-stack.svg';
import CommentIcon from '../../../../assets/comment-article-icon.svg';
import ShareIcon from '../../../../assets/share-gray-icon.svg';
import IgnoreIcon from '../../../../assets/ignore-gray-icon.svg';
import UnignoreIcon from '../../../../assets/ignore-green-icon.svg';
import SaveIcon from '../../../../assets/save-gray-icon.svg';
import SavedIcon from '../../../../assets/saved-gray-icon.svg';
import DefaultThumbnail from '../../../../assets/default-thumnail.png';
import AvatarDefault from '../../../../assets/small_default_optimized.png';
import VerifiedIcon from '../../../../assets/verified-icon.svg';
import FoundingCreatorIcon from '../../../../assets/founding_creator_icon.png';
import { convertCountLike } from '../../../../constants';
import BadgeWithTooltip from '../../../BadgeWithTooltip';
import { BADGE_INFO } from '../../../../constants/badges';
import { format } from 'date-fns';
import {
  saveArticle,
  unsaveArticle,
  ignoreArticle,
  unignoreArticle
} from '../../../../apis/article.api';
import { useToast } from '@chakra-ui/react';
import ToastBtnMessage from '../../../ToastBtnMessage';
import React, { useEffect, useState } from 'react';
import ShareContentModal from '../../../ShareContentModal';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAtom } from 'jotai';
import { profileAtom } from '../../../Settings/atom';
import RankBadge from '../../../RankBadge';
import PointIcon from '../../../../assets/point-icon.svg';
import { WriterBadgeInfo } from '../../../WriterBadgeInfo';
import SensitiveContentCard from '../../../SensitiveContentCard';
import useRankBadgeTooltip from '../../../../hooks/useRankBadgeTooltip';
import DataLayer from '../../../../utils/data-layer';
import { handleUserClick } from '../../../../utils/helper.util';
import ReactionBadge from '../../../ReactionBadge';
import TwigsBadge from '../../../TwigsBadge';
import { UnauthorizedDispatcher } from 'src/utils/unauthorized-dispatcher';

const CardArticle = ({
  item = {},
  index,
  isHiddenFeaturedArticles,
  isPreview,
  isProfile,
  isHiddenCreatorInfo = false
}) => {
  const [modal, setModal] = useState('');
  const navigate = useNavigate();
  const [isSaved, setIsSaved] = useState(item.isSaved);
  const [isIgnored, setIsIgnored] = useState(item.isIgnored);
  const toast = useToast();
  const [profile] = useAtom(profileAtom);
  const [showSensitiveContentCard, setShowSensitiveContentCard] = useState(false);
  const [searchParams] = useSearchParams();
  const {
    openPopup,
    totalAwardedPoints,
    isTouchDevice,
    handleMouseEnter,
    handleClick,
    handleMouseLeave
  } = useRankBadgeTooltip();
  const userId = JSON.parse(localStorage.getItem('user'))?.id;

  async function handleSaveArticle(articleId) {
    if (!userId) return UnauthorizedDispatcher('required');

    let message = 'Error';
    let isError = false;
    let btnTitle = undefined;
    let btnAction = undefined;

    if (isSaved) {
      await unsaveArticle(articleId)
        .then(() => {
          message = 'Article has been removed from your Reading List successfully!';
          btnTitle = 'View Reading List';
          btnAction = () => {
            window.location.href = '/?tab=myReading';
          };
          setIsSaved(false);
        })
        .catch((error) => {
          message = 'Couldn’t remove article from your Reading List!';
          isError = true;
          btnTitle = 'retry';
          btnAction = () => {
            handleSaveArticle(articleId);
          };
          console.log(error);
        });
    } else {
      await saveArticle(articleId)
        .then(() => {
          message = 'Article has been saved to your Reading List successfully!';
          btnTitle = 'View Reading List';
          btnAction = () => {
            window.location.href = '/?tab=myReading';
          };
          setIsSaved(true);

          // Track article bookmark event
          if (item) {
            const articleType = item.writingType?.name;
            DataLayer.trackArticleBookmark(articleType, articleId);
          }
        })
        .catch((error) => {
          message = 'Couldn’t save article to your Reading List!';
          isError = true;
          btnTitle = 'retry';
          btnAction = () => {
            handleSaveArticle(articleId);
          };
          console.log(error);
        });
    }
    toast({
      render: () => (
        <ToastBtnMessage
          title={message}
          isError={isError}
          color="jet-black"
          btnTitle={btnTitle}
          btnAction={btnAction}
        ></ToastBtnMessage>
      ),
      status: 'error',
      duration: 2000,
      isClosable: true,
      position: 'top-right'
    });
  }

  async function handleIgnoreArticle(articleId, toastIsIgnored) {
    if (!userId) return UnauthorizedDispatcher('required');

    let message = 'Error';
    let isError = false;
    let btnTitle = undefined;
    let btnAction = undefined;
    let isHiddenButton = false;

    //This is meant to fix the issue with toasts using the unupdated version of isIgnored state.
    let capturedIgnored = isIgnored;
    if (toastIsIgnored !== undefined) {
      capturedIgnored = toastIsIgnored;
    }

    if (capturedIgnored === true) {
      await unignoreArticle(articleId)
        .then(() => {
          message = 'Article restored. You can read it again.';
          isHiddenButton = true;
          setIsIgnored(false);
        })
        .catch((error) => {
          message = 'Couldn’t restore article!';
          isError = true;
          btnTitle = 'Retry';
          btnAction = () => {
            handleIgnoreArticle(articleId);
          };
          console.log(error);
        });
    } else if (capturedIgnored === false) {
      await ignoreArticle(articleId)
        .then(async () => {
          message = `Article ignored. You won't see it again.`;
          btnTitle = 'Undo';
          btnAction = () => {
            handleIgnoreArticle(articleId, !isIgnored);
          };
          await unsaveArticle(articleId);
          setIsSaved(false);
          setIsIgnored(true);
        })
        .catch((error) => {
          message = 'Couldn’t ignore article!';
          isError = true;
          btnTitle = 'Retry';
          btnAction = () => {
            handleIgnoreArticle(articleId);
          };
          console.log(error);
        });
    }
    toast({
      render: () => (
        <ToastBtnMessage
          title={message}
          isError={isError}
          color="jet-black"
          btnTitle={btnTitle}
          btnAction={btnAction}
          isHiddenButton={isHiddenButton}
        ></ToastBtnMessage>
      ),
      status: 'error',
      duration: 10000,
      isClosable: true,
      position: 'top-right'
    });
  }

  useEffect(() => {
    setIsSaved(item.isSaved);
  }, [item.isSaved]);

  useEffect(() => {
    if (item?.moderation?.showWarning !== undefined) {
      setShowSensitiveContentCard(item.moderation.showWarning);
    }
  }, [item]);

  return (
    <div className="relative py-4 md:py-6">
      {showSensitiveContentCard && !item?.isShowSensitive && (
        <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-10">
          <SensitiveContentCard
            actionButton={item?.moderation?.actionButton}
            primarySource={item?.moderation?.primarySource}
            primaryViolation={item?.moderation?.primaryViolation}
            setShowSensitiveContentCard={setShowSensitiveContentCard}
            articleId={item?.id}
            isShowSensitive={item?.isShowSensitive}
          />
        </div>
      )}
      <div className="flex flex-col gap-2">
        <div className="w-full flex items-start gap-3 md:gap-5">
          <div className="flex flex-col gap-2 flex-1 min-w-0">
            {(isProfile && searchParams.get('tab') === 'myArticles') || isHiddenCreatorInfo ? (
              <></>
            ) : (
              <div className="flex items-start md:items-center gap-[8px] cursor-pointer">
                {isPreview ? (
                  <img
                    className="w-10 h-10 flex-shrink-0 rounded-full object-cover"
                    src={item?.imgUrl || AvatarDefault}
                    alt=""
                  />
                ) : (
                  <a
                    href={`/${item?.creator?.username}`}
                    onClick={(e) =>
                      handleUserClick(e, () => {
                        e.preventDefault();
                        navigate(`/${item?.creator?.username}`);
                      })
                    }
                  >
                    <img
                      className="w-10 h-10 flex-shrink-0 rounded-full object-cover"
                      src={item?.imgUrl || AvatarDefault}
                      alt=""
                    />
                  </a>
                )}
                {isPreview ? (
                  <div className="flex flex-col min-w-0 flex-1 -space-y-0.5">
                    {/* First line: Name + Verified + Reputation Badge + You Badge */}
                    <div className="flex items-center gap-1 min-w-0 flex-wrap leading-tight">
                      <p
                        title={item?.nameCreator}
                        className="font-[700] text-sm hover:text-growth-green-500 truncate transition duration-200 leading-tight"
                      >
                        {item?.nameCreator || 'Anonymous'}
                      </p>
                      {item?.creator?.isVerifiedAuthor && (
                        <BadgeWithTooltip
                          icon={VerifiedIcon}
                          alt="Verified Author"
                          title={BADGE_INFO.VERIFIED_AUTHOR.title}
                          description={BADGE_INFO.VERIFIED_AUTHOR.description}
                          className="w-3.5 h-3.5"
                        />
                      )}
                      {item?.creator?.isFoundingCreator && (
                        <BadgeWithTooltip
                          icon={FoundingCreatorIcon}
                          alt="Founding Creator"
                          title={BADGE_INFO.FOUNDING_CREATOR.title}
                          description={BADGE_INFO.FOUNDING_CREATOR.description}
                          className="w-7 h-7"
                        />
                      )}
                      <div
                        className="relative flex-shrink-0 scale-75 -ml-1"
                        onMouseEnter={() => !isTouchDevice && handleMouseEnter(item?.creator?.id)}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleClick(item?.creator?.id);
                        }}
                        onMouseLeave={() => !isTouchDevice && handleMouseLeave()}
                      >
                        <RankBadge rank={item?.creator?.currentRank} hiddenRankText />
                        {openPopup && (
                          <div className="absolute top-[34px] md:top-[-20px] left-[-50%] md:left-[50px] z-10">
                            <WriterBadgeInfo
                              rank={item?.creator?.currentRank}
                              totalReceivedPoint={totalAwardedPoints.totalReceivedPoint}
                              totalReceivedUsers={totalAwardedPoints.totalReceivedUsers}
                            />
                          </div>
                        )}
                      </div>
                      {item?.creator?.id === profile.id && (
                        <div className="px-1.5 py-0.5 rounded-full bg-growth-green-50 text-[9px] text-growth-green-900 font-[600] whitespace-nowrap flex-shrink-0">
                          You
                        </div>
                      )}
                    </div>

                    {/* Second line: Username (tightly spaced below name) */}
                    {item?.creator?.username && (
                      <span className="font-[600] text-xs text-02-dim-gray truncate leading-tight">
                        @{item?.creator?.username}
                      </span>
                    )}
                  </div>
                ) : (
                  <a
                    href={`/${item?.creator?.username}`}
                    className="flex flex-col min-w-0 flex-1 -space-y-0.5"
                    onClick={(e) =>
                      handleUserClick(e, () => {
                        e.preventDefault();
                        navigate(`/${item?.creator?.username}`);
                      })
                    }
                  >
                    {/* First line: Name + Verified + Reputation Badge + You Badge */}
                    <div className="flex items-center gap-1 min-w-0 flex-wrap leading-tight">
                      <p
                        title={item?.nameCreator}
                        className="font-[700] text-sm hover:text-growth-green-500 truncate transition duration-200 leading-tight"
                      >
                        {item?.nameCreator || 'Anonymous'}
                      </p>
                      {item?.creator?.isVerifiedAuthor && (
                        <BadgeWithTooltip
                          icon={VerifiedIcon}
                          alt="Verified Author"
                          title={BADGE_INFO.VERIFIED_AUTHOR.title}
                          description={BADGE_INFO.VERIFIED_AUTHOR.description}
                          className="w-3.5 h-3.5"
                        />
                      )}
                      {item?.creator?.isFoundingCreator && (
                        <BadgeWithTooltip
                          icon={FoundingCreatorIcon}
                          alt="Founding Creator"
                          title={BADGE_INFO.FOUNDING_CREATOR.title}
                          description={BADGE_INFO.FOUNDING_CREATOR.description}
                          className="w-7 h-7"
                        />
                      )}
                      <div
                        className="relative flex-shrink-0 scale-75 -ml-1"
                        onMouseEnter={() => !isTouchDevice && handleMouseEnter(item?.creator?.id)}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleClick(item?.creator?.id);
                        }}
                        onMouseLeave={() => !isTouchDevice && handleMouseLeave()}
                      >
                        <RankBadge rank={item?.creator?.currentRank} hiddenRankText />
                        {openPopup && (
                          <div className="absolute top-[34px] md:top-[-20px] left-[-50%] md:left-[50px] z-10">
                            <WriterBadgeInfo
                              rank={item?.creator?.currentRank}
                              totalReceivedPoint={totalAwardedPoints.totalReceivedPoint}
                              totalReceivedUsers={totalAwardedPoints.totalReceivedUsers}
                            />
                          </div>
                        )}
                      </div>
                      {item?.creator?.id === profile.id && (
                        <div className="px-1.5 py-0.5 rounded-full bg-growth-green-50 text-[9px] text-growth-green-900 font-[600] whitespace-nowrap flex-shrink-0">
                          You
                        </div>
                      )}
                    </div>

                    {/* Second line: Username (tightly spaced below name) */}
                    {item?.creator?.username && (
                      <span className="font-[600] text-xs text-02-dim-gray truncate leading-tight">
                        @{item?.creator?.username}
                      </span>
                    )}
                  </a>
                )}
              </div>
            )}
            <div
              className={`flex flex-col md:gap-2 ${showSensitiveContentCard && !item?.isShowSensitive ? 'blur-lg' : ''}`}
            >
              <div className="flex items-center gap-2">
                <p className="text-growth-green-900 font-semibold text-[10px] whitespace-nowrap">
                  {item?.writingType?.name || item?.writingType}
                </p>
                <span className="text-growth-green-900 font-semibold text-[10px]">•</span>
                <p className="font-[600] text-[10px] !text-02-dim-gray">
                  {format(item?.createdAt || new Date(), 'dd MMM yyyy')}
                </p>
                <p className="font-[600] !text-02-dim-gray text-[10px]">
                  {item?.readLength || '0 min'} read
                </p>
              </div>
              <div>
                {isPreview ? (
                  <h1
                    className="font-[800] mb-1 line-clamp-3 md:line-clamp-2 cursor-pointer hover:underline text-sm md:text-lg"
                    title={item?.title}
                  >
                    {item?.title}
                  </h1>
                ) : (
                  <a
                    href={`/articles/${item?.alternativeId || item?.id}`}
                    className="font-[800] mb-1 line-clamp-3 md:line-clamp-2 cursor-pointer hover:underline text-sm md:text-lg block"
                    title={item?.title}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`/articles/${item?.alternativeId || item?.id}`);
                    }}
                  >
                    {item?.title}
                  </a>
                )}
                <p className="hidden md:!line-clamp-2 text-sm" title={item?.description}>
                  {item?.description}
                </p>

                {item?.userReactionData?.primaryReactionType && (
                  <div className="mt-2">
                    <ReactionBadge
                      primaryReactionType={item.userReactionData.primaryReactionType}
                      reactionSummary={item.userReactionData.reactionSummary}
                      totalReactions={item.userReactionData.totalReactions}
                      size="sm"
                      showTooltip={true}
                    />
                  </div>
                )}

                {item?.userTwigsData && item.userTwigsData.totalTwigsGiven > 0 && (
                  <div className="mt-2">
                    <TwigsBadge
                      totalTwigsGiven={item.userTwigsData.totalTwigsGiven}
                      transactionCount={item.userTwigsData.transactionCount}
                      mostRecentDate={item.userTwigsData.mostRecentDate}
                      mostRecentAmount={item.userTwigsData.mostRecentAmount}
                      averageBiasWeight={item.userTwigsData.averageBiasWeight}
                      size="sm"
                      showTooltip={true}
                    />
                  </div>
                )}
              </div>

              <div className="hidden md:!flex items-center flex-wrap gap-2 md:gap-4">
                {item?.topics?.slice(0, 3).map((elm) =>
                  isPreview ? (
                    <p
                      className="bg-[#F0EDEC] rounded-[80px] !text-earth-brown-500 font-semibold text-[10px] px-2 py-0.5 whitespace-nowrap cursor-pointer hover:bg-[#E8E4E3] transition-colors duration-200"
                      key={elm.id}
                    >
                      {elm?.name}
                    </p>
                  ) : (
                    <a
                      href={`/recommended-topics?topicId=${elm.id}`}
                      className="bg-[#F0EDEC] rounded-[80px] !text-earth-brown-500 font-semibold text-[10px] px-2 py-0.5 whitespace-nowrap cursor-pointer hover:bg-[#E8E4E3] transition-colors duration-200"
                      key={elm.id}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        navigate(`/recommended-topics?topicId=${elm.id}`);
                      }}
                    >
                      {elm?.name}
                    </a>
                  )
                )}
              </div>
            </div>
            <div className="hidden md:!flex gap-4 items-center">
              <div className="flex items-center flex-wrap gap-4">
                <div className="flex items-center relative gap-1">
                  <img className="h-4" src={ReactStackIcon} alt="" />
                  <p className="font-[600] text-xs">{convertCountLike(item?.reactionNumber)}</p>
                </div>
                <div className="flex items-center gap-1">
                  <img className="h-4" src={CommentIcon} alt="" />
                  <p className="font-[600] text-xs">{item?.commentNumber || 0}</p>
                </div>
                <div className="flex gap-1 items-center py-1 px-2 border border-[#C8E6C9] bg-06-seasalt-white rounded-[80px] h-6">
                  <img className="h-4" src={PointIcon} alt="" />
                  <p className="text-[#204A22] text-xs font-[800]">
                    {item?.reputationPoint?.amount || 0}{' '}
                    {item?.reputationPoint?.amount === 1 ? 'Twig' : 'Twigs'}
                  </p>
                </div>
              </div>

              <div className="flex items-center ml-auto gap-2">
                <img
                  src={ShareIcon}
                  alt=""
                  className="cursor-pointer lg:h-[16px] xl:h-5"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!isPreview) {
                      setModal('share-article');
                    }
                  }}
                />
                <img
                  src={isSaved ? SavedIcon : SaveIcon}
                  alt=""
                  className="cursor-pointer lg:h-[16px] xl:h-5"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!isPreview) {
                      handleSaveArticle(item?.id);
                    }
                  }}
                />
                {!isProfile && (
                  <img
                    src={isIgnored ? UnignoreIcon : IgnoreIcon}
                    alt=""
                    className="cursor-pointer lg:h-[16px] xl:h-5"
                    onClick={() => {
                      if (!isPreview) {
                        handleIgnoreArticle(item?.id);
                      }
                    }}
                  />
                )}
              </div>
            </div>
          </div>
          <div
            className={`relative flex-shrink-0 w-[120px] h-[80px] sm:w-[180px] sm:h-[120px] md:w-[280px] md:h-[160px] lg:w-[320px] lg:h-[180px] ${showSensitiveContentCard && !item?.isShowSensitive ? 'blur-lg' : ''}`}
          >
            {isPreview ? (
              <img
                className="w-full h-full object-cover rounded-lg cursor-pointer"
                src={item?.cover || DefaultThumbnail}
                alt={item?.title || 'Article thumbnail'}
              />
            ) : (
              <a
                href={`/articles/${item?.alternativeId || item?.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(`/articles/${item?.alternativeId || item?.id}`);
                }}
                className="block w-full h-full"
              >
                <img
                  className="w-full h-full object-cover rounded-lg cursor-pointer"
                  src={item?.cover || DefaultThumbnail}
                  alt={item?.title || 'Article thumbnail'}
                />
              </a>
            )}
            <div
              className={`absolute left-1 whitespace-nowrap md:left-[120px] top-1 bg-[#EDF7EE] rounded-[80px] py-1 px-1 md:px-[10px] text-[8px] md:text-[10px] font-[800] !text-[#204A22] ${
                index === 0 && !isHiddenFeaturedArticles ? 'hidden' : 'hidden' // temporary always hidden
              }`}
            >
              Featured Article
            </div>
          </div>
        </div>

        {/* Mobile */}
        <div
          className={`md:hidden ${showSensitiveContentCard && !item?.isShowSensitive ? 'blur-lg' : ''}`}
        >
          <div className="flex flex-wrap items-center gap-2">
            {item?.topics?.slice(0, 3).map((elm) => {
              return isPreview ? (
                <p
                  className="bg-[#F0EDEC] rounded-[80px] !text-earth-brown-500 font-semibold text-[10px] px-2 py-0.5 whitespace-nowrap cursor-pointer hover:bg-[#E8E4E3] transition-colors duration-200"
                  key={elm.id}
                >
                  {elm?.name}
                </p>
              ) : (
                <a
                  href={`/recommended-topics?topicId=${elm.id}`}
                  className="bg-[#F0EDEC] rounded-[80px] !text-earth-brown-500 font-semibold text-[10px] px-2 py-0.5 whitespace-nowrap cursor-pointer hover:bg-[#E8E4E3] transition-colors duration-200"
                  key={elm.id}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    navigate(`/recommended-topics?topicId=${elm.id}`);
                  }}
                >
                  {elm?.name}
                </a>
              );
            })}
          </div>
        </div>
        <div className="flex md:hidden items-center gap-4 md:gap-5">
          <div className="flex flex-wrap gap-2">
            <div className="flex items-center relative gap-1">
              <img src={ReactStackIcon} className="h-4" alt="" />
              <p className="font-[600] text-xs">{convertCountLike(item?.reactionNumber)}</p>
            </div>
            <div className="flex items-center gap-1">
              <img src={CommentIcon} className="h-4" alt="" />
              <p className="font-[600] text-xs">{item?.commentNumber || 0}</p>
            </div>
            <div className="flex gap-1 items-center py-1 px-2 border border-[#C8E6C9] bg-06-seasalt-white rounded-[80px] w-fit h-6">
              <img src={PointIcon} className="h-4" alt="" />
              <p className="text-[#204A22] font-[800] text-xs">
                {item?.reputationPoint?.amount || 0} Points
              </p>
            </div>
          </div>
          <div className="flex items-center ml-auto gap-2">
            <img
              src={ShareIcon}
              alt=""
              className="cursor-pointer h-5"
              onClick={(e) => {
                e.stopPropagation();
                if (!isPreview) {
                  setModal('share-article');
                }
              }}
            />
            <img
              src={isSaved ? SavedIcon : SaveIcon}
              alt=""
              className="cursor-pointer h-5"
              onClick={(e) => {
                e.stopPropagation();
                if (!isPreview) {
                  handleSaveArticle(item.id);
                }
              }}
            />
            {!isProfile && (
              <img
                src={isIgnored ? UnignoreIcon : IgnoreIcon}
                alt=""
                className="cursor-pointer h-5"
                onClick={() => {
                  if (!isPreview) {
                    handleIgnoreArticle(item.id);
                  }
                }}
              />
            )}
          </div>
        </div>
        {modal === 'share-article' ? (
          <ShareContentModal
            isOpen
            title="Share Article"
            smallTitle="Share this Article!"
            shareUrl={`${process.env.REACT_APP_NEWSLETTER_URL}articles/${item?.alternativeId || item?.id}`}
            media={item?.cover}
            articleId={item?.alternativeId || item?.id}
            onClick={() => setModal('')}
            titleBtn="Done"
            minW="439px"
          />
        ) : null}
      </div>
    </div>
  );
};

export default CardArticle;
